import React from "react";
import Drawer from "../ui/Drawer";
import OccurrenceList from "./OccurrenceList";
import SprintGroupHeader from "./SprintGroupHeader";
import { occurrenceCountLabel } from "../../domain/inconsistencies";
import { RULE_GROUP_META } from "../../domain/inconsistencyRules";

// A contagem sai dos grupos que o painel lista, não da tabela: um número no
// cabeçalho que não fecha com o que está logo abaixo dele não descreve nada.
function totalOf(groups) {
  return groups.reduce((total, group) => total + group.items.length, 0);
}

function RuleDrawer({ rule, groups, onClose }) {
  const meta = RULE_GROUP_META[rule.group];

  return (
    <Drawer
      title={rule.label}
      subtitle={`${meta.label} • ${occurrenceCountLabel(totalOf(groups))}`}
      onClose={onClose}
    >
      <p className="drawer-note">{rule.description}</p>

      {groups.map((group) => (
        <section
          className="drawer-group"
          key={group.key}
          aria-labelledby={`drawer-${group.key}-title`}
        >
          <SprintGroupHeader
            id={`drawer-${group.key}-title`}
            title={group.title}
            count={group.items.length}
          />
          <OccurrenceList items={group.items} />
        </section>
      ))}
    </Drawer>
  );
}

export default RuleDrawer;
